module.exports = __webpack_public_path__ + "img/cellres_shaojun_2021.8b662581.jpg";